import { GTMTracker } from './trackers';
import { storage } from '@/utils/storage';
import { User } from '@shop/models/src/identity';

interface TrackerInterface {
  initiate(): void;
  record(event: any): void;
}

const tracking = (trackers: TrackerInterface[]) => {
  let initiated = false;

  return {
    initiate: () => {
      trackers.forEach((tracker) => tracker.initiate());
      initiated = true;
    },
    record: (event) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn('tracking received an event', event);
      }
      if (initiated) {
        trackers.forEach((tracker) => tracker.record(event));
      }
    },
  };
};

const trackers: TrackerInterface[] = [GTMTracker];

export const makeEvent = (name: string, payload: any) => {
  const user = storage.local.user.get<User>();

  payload = {
    ...payload,
    ...(user
      ? {
          user_mobile: user.mobileNumber,
        }
      : {}),
  };

  const ga = {
    event: name,
    ...payload,
  };

  return {
    ga,
  };
};

export default tracking(trackers);
